import { createNotification } from "react-redux-notify";
import { select, put, takeLatest, all } from "redux-saga/effects";

import {
  fetchHomeStoriesSuccess,
  fetchHomeStoriesFailure,
  fetchProfileStoriesSuccess,
  fetchProfileStoriesFailure,
  saveStoryFailure,
  saveStorySuccess,
  saveStoryFromPostFailure,
  saveStoryFromPostSuccess,
  deleteStorySuccess,
  deleteStoryFailure,
  UpdateStoryDataStatusSuccess,
  fetchStorySuccess,
  fetchStoryFailure
} from "../actions/StoriesAction";
import {
  FETCH_HOME_STORIES_START,
  FETCH_PROFILE_STORIES_START,
  SAVE_FROM_POST_START,
  SAVE_STORY_START,
  UPDATE_STORY_DATA_STATUS_START,
  DELETE_STORY_START,
  FETCH_STORY_START,
} from "../actions/ActionConstant";
import {
  getErrorNotificationMessage, getSuccessNotificationMessage
} from "../../components/helper/NotificationMessage";
import { updatePostFeedStoryStatus } from "../actions/HomeAction";
import StoryService from '../../helpers/services/content/story.service';
import { parseContentServiceError } from "../../helpers/services/content/error";
import { updatePostHasStoryStatus, updateSinglePostHasStoryStatus } from "../actions/PostAction";
import _ from "lodash"
import { hideErrorComponent, showErrorComponent } from "../actions/ComponentAction";

function* fetchHomeStoriesAPI(action) {
  try {
    const response = yield StoryService.getHomeStory(action.data);
    if (response.data) {
      yield put(fetchHomeStoriesSuccess({
        data: _.union(response.lives.map((live, ind) => {
          return {
            ...live,
            user_id: `live${ind}`
          }
        }), response.data), metadata: response.metadata?.pagination
      }));
      yield put(hideErrorComponent());
    } else {
      yield put(fetchHomeStoriesFailure(response.data));
    }
  } catch (error) {
    yield put(fetchHomeStoriesFailure(error));
  }
}

function* fetchProfileStoriesAPI(action) {
  try {
    const response = yield StoryService.getProfileStory(action.data);
    if (response.data) {
      yield put(fetchProfileStoriesSuccess({ data: response.data, metadata: response.metadata?.pagination }));
      yield put(hideErrorComponent());
    } else {
      yield put(fetchProfileStoriesFailure(response.data));
    }
  } catch (error) {
    yield put(fetchProfileStoriesFailure(error));
  }
}


function* fetchStoryAPI(action) {
  try {
    const response = yield StoryService.getStory(action.data);
    if (response?.id) {
      yield put(fetchStorySuccess(response));
    } else {
      yield put(fetchStoryFailure(response));
    }
    yield put(hideErrorComponent());
  } catch (error) {
    yield put(fetchStoryFailure(error));
  }
}

function* saveStoryAPI() {
  try {
    const inputData = yield select((state) => state.stories.saveStory.inputData);
    const { onUploadProgress, ...payload } = inputData

    if (!payload.post_files) {
      yield put(saveStoryFailure("Please fill the content"));
      const notificationMessage = getErrorNotificationMessage(
        "Please fill the content"
      );
      yield put(createNotification(notificationMessage));
    }
    const response = yield StoryService.createStory(payload, {
      onUploadProgress: (event) => {
        let progress = (event.loaded / event.total) * 100;
        onUploadProgress(Math.ceil(progress));
      }
    });

    yield put(saveStorySuccess(response));
    const notificationMessage = getSuccessNotificationMessage(
      "Story created successfully!"
    );
    yield put(createNotification(notificationMessage));
    yield put(hideErrorComponent());
    window.location.assign("/home");
  } catch (error) {
    yield put(saveStoryFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(parseContentServiceError(error.response));
    yield put(createNotification(notificationMessage));
  }
}

function* saveStoryFromPost() {
  try {
    const inputData = yield select((state) => state.stories.saveFromPost.inputData);

    if (!inputData.post_id) {
      yield put(saveStoryFromPostFailure('Post id is required!'));
      const notificationMessage = getErrorNotificationMessage('Post id is required!');
      yield put(createNotification(notificationMessage));
    }
    const response = yield StoryService.createStoryFromPost(inputData);
    yield put(saveStoryFromPostSuccess(response));
    yield put(updatePostHasStoryStatus(inputData));
    yield put(updatePostFeedStoryStatus(inputData));
    yield put(updateSinglePostHasStoryStatus(inputData));
    const notificationMessage = getSuccessNotificationMessage('Story created successfully!');
    yield put(createNotification(notificationMessage));
    yield put(hideErrorComponent());
  } catch (error) {
    yield put(saveStoryFromPostFailure(error));
    const notificationMessage = getErrorNotificationMessage(
      parseContentServiceError(error.response),
    );
    yield put(createNotification(notificationMessage));
  }
}

function* updateStoryReadStatus() {
  try {
    const inputData = yield select((state) => state.stories.updateStoryStatus.inputData);

    if (!inputData.story_id) {
      const notificationMessage = getErrorNotificationMessage('Story id is required!');
      yield put(createNotification(notificationMessage));
    } else {
      const response = yield StoryService.updateStoryReadStatus(inputData);

      if (response.id) {
        yield put(UpdateStoryDataStatusSuccess(inputData));
        yield put(hideErrorComponent());
      } else {
        const notificationMessage = getErrorNotificationMessage(
          getErrorNotificationMessage(response.data.error),
        );
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    const notificationMessage = getErrorNotificationMessage(
      parseContentServiceError(error.response),
    );
    yield put(createNotification(notificationMessage));
  }
}

function* deleteStoryAPI() {
  try {
    const inputData = yield select((state) => state.stories.delStory.inputData);
    const response = yield StoryService.deleteStory(inputData);
    if (response.success) {
      yield put(deleteStorySuccess(inputData));
      const notificationMessage = getSuccessNotificationMessage(
        response.message
      );
      yield put(createNotification(notificationMessage));
      yield put(hideErrorComponent());
      // window.location.assign("/profile");
    } else {
      yield put(deleteStoryFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(deleteStoryFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(FETCH_HOME_STORIES_START, fetchHomeStoriesAPI)]);
  yield all([yield takeLatest(FETCH_PROFILE_STORIES_START, fetchProfileStoriesAPI)]);
  yield all([yield takeLatest(FETCH_STORY_START, fetchStoryAPI)]);
  yield all([yield takeLatest(SAVE_STORY_START, saveStoryAPI)]);
  yield all([yield takeLatest(SAVE_FROM_POST_START, saveStoryFromPost)])
  yield all([yield takeLatest(UPDATE_STORY_DATA_STATUS_START, updateStoryReadStatus)]);
  yield all([yield takeLatest(DELETE_STORY_START, deleteStoryAPI)]);

}
